var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"hidden-sm-and-down",attrs:{"cols":"12","md":"4"}}),_c('v-col',[_c('p',{staticClass:"text-center text-md-left"},[_vm._v(_vm._s(_vm.text ? _vm.text: "Es gibt noch keine Informationen"))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }